
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductModel } from './Entities.GormCrm.Product';
import { Model, ModelProperty } from 'models/Model';


export class ProductTagModel extends Model<ProductTagModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'tag', type: 'string' },
		{ name: 'productId', type: 'string' },
		{ name: 'product', type: 'ProductModel', isHidden: true, isObject: true, new: () => { return new ProductModel }, properties: () => { return ProductModel.classProperties } }
	];
	[key: string]: any;
	
	public tag: string;
	public productId?: string;
	public product?: ProductModel;
    
	constructor(){
		super();
		this.tag = '';
		this.productId = undefined;
		this.product = undefined;
		
	}
	getProperties(){
		return ProductTagModel.classProperties;
	}
}

